import React, { useEffect } from 'react'
import { createPortal } from 'react-dom';
import Box from 'schoolUiComponents/basic/Box';
import FlexBox from 'schoolUiComponents/basic/Box/FlexBox';
import PositionBox from 'schoolUiComponents/basic/Box/PositionBox';
import styled from 'styled-components';

interface IPopupViewerProps {
    children: JSX.Element | any;
    closeCallback: (type: string) => void;
    autoClose?: boolean;
    autoCloseTimeout?: number;
    showCrossIcon?: boolean;
    padding?: string | number;
    top?: string;
    zIndex?: number;
    scroll?: boolean;
}

const OverlayDiv = styled.div<{ zIndex: number, scroll: boolean }>`
    background: rgba(0, 0, 0, 0.6);
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: ${props => props.zIndex || 1000};
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    ${(props) => props.scroll && `
        align-items: flex-start;
        overflow-y: auto;
    `}
`;

let autoCloseTimer: any = null;
const PopupViewer: React.FC<IPopupViewerProps> = ({ closeCallback, autoClose = false, autoCloseTimeout = 5000, showCrossIcon = true, top = 'auto', padding = 24, children, zIndex, scroll }) => {

    const closeHandler = (type: string) => {
        autoCloseTimer && clearTimeout(autoCloseTimer);
        closeCallback(type);
    }

    useEffect(() => {
        if (autoClose) {
            autoCloseTimer = setTimeout(() => {
                closeHandler('Auto close');
            }, autoCloseTimeout);
        }
    }, [])

    return (
        <OverlayDiv zIndex={zIndex || 1000} scroll={scroll}>
            <FlexBox className='sui-popup' alignStart gap={8}>
                <PositionBox.relative backgroundColor="#FFFFFF" borderRadius={16} shadow padding={padding} top={top}>
                    {showCrossIcon && <PositionBox.absolute right={-20} top={6} onClick={() => closeHandler('Cross icon')}><i className="iconcust-iconCross cross-icon" style={{ color: "#FFFFFF" }} /></PositionBox.absolute>}
                    {children}
                </PositionBox.relative>
            </FlexBox>
        </OverlayDiv>
    )
}

export default PopupViewer